import Favorites from './Favorites';

export default Favorites;



// WEBPACK FOOTER //
// ./src/components/Favorites/index.js